import React, { Component } from 'react';
import Sec1 from './sections/Sec1';

class Sections extends Component {
  render() {
    return (
      <div>
        <Sec1 />
      </div>
    );
  }
}

export default Sections;



// WEBPACK FOOTER //
// ./src/components/Sections.js